import React, { Component } from "react";

import PopularListItemsDesktop from "./PopularListItemsDesktop";
import NotPopularListItemsDesktop from "./NotPopularListItemsDesktop";

export default class List extends Component {
  render() {
    const {
      popularCategories,
      notPopularCategories,
      handleSelectCategory,
      regexCategories
    } = this.props || [];
    return (
      <div className="search-page search-desktop">
        <div className="container">
          <div className="padding">
            {(regexCategories && regexCategories.length && (
              <div className="search-list">
                <ul className="">
                  {regexCategories.map(category => (
                    <li
                      className="list-regex-item"
                      key={category.id}
                      onClick={() =>
                        handleSelectCategory(
                          category.name,
                          category.resultType,
                          category.uid,
                          category.restaurantAddressPostalCode,
                          category.restaurantAddressSlugAdminWard,
                          category.restaurantAddressSlugCityName,
                          category.restaurantSlugName
                        )
                      }
                    >
                      {category.name}
                    </li>
                  ))}
                </ul>
              </div>
            )) || <noscript />}
            <div className="row">
              <div className="col-sm-7">
                <h5>Most Popular Categories</h5>
                <ul className="search-categories">
                  {(popularCategories.length &&
                    popularCategories.map(category => (
                      <PopularListItemsDesktop
                        key={category.id}
                        handleSelectCategory={handleSelectCategory}
                        category={category}
                      />
                    ))) || <noscript />}
                </ul>
              </div>
              <div className="col-sm-5">
                <h5>More Categories</h5>
                <ul className="white-bg other-list">
                  {(notPopularCategories.length &&
                    notPopularCategories.map(category => (
                      <NotPopularListItemsDesktop
                        key={category.id}
                        handleSelectCategory={handleSelectCategory}
                        category={category}
                      />
                    ))) || <noscript />}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
